export default __webpack_public_path__ + "static/media/wecommerce-logo-flat.334508a8.png";